import React from 'react';
import './AccountVerificationSuccess.css';

const AccountVerificationSuccess: React.FC = () => {
  const handleGetStarted = () => {
    // Navigate to onboarding or dashboard
    window.location.href = '/';
  };

  const handleExploreFeatures = () => {
    // Navigate to features page or tutorial
    console.log('Explore features clicked');
  };

  return (
    <div className="account-verification-success-container">
      <div className="verification-success-card">
        <div className="celebration-header">
          <div className="success-badge">
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
              <circle cx="50" cy="50" r="50" fill="#10B981"/>
              <path d="M30 50L42 62L70 34" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="confetti">
            <div className="confetti-piece"></div>
            <div className="confetti-piece"></div>
            <div className="confetti-piece"></div>
            <div className="confetti-piece"></div>
            <div className="confetti-piece"></div>
            <div className="confetti-piece"></div>
          </div>
        </div>
        
        <h1 className="success-title">Account Verified Successfully!</h1>
        <p className="success-subtitle">
          🎉 Congratulations! Your Sportagram account has been fully verified and activated. 
          You're now part of the ultimate sports community!
        </p>
        
        <div className="verification-status">
          <div className="status-item completed">
            <div className="status-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" fill="currentColor"/>
              </svg>
            </div>
            <span>Email verified</span>
          </div>
          <div className="status-item completed">
            <div className="status-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" fill="currentColor"/>
              </svg>
            </div>
            <span>Account activated</span>
          </div>
          <div className="status-item completed">
            <div className="status-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" fill="currentColor"/>
              </svg>
            </div>
            <span>Profile ready</span>
          </div>
        </div>
        
        <div className="welcome-features">
          <h2 className="features-title">What you can do now:</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🏆</div>
              <h3>Join Competitions</h3>
              <p>Participate in exciting sports tournaments and challenges</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3>Connect with Athletes</h3>
              <p>Follow your favorite players and sports personalities</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Track Performance</h3>
              <p>Monitor your progress and achievements</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Set Goals</h3>
              <p>Create and achieve your sports objectives</p>
            </div>
          </div>
        </div>
        
        <div className="action-buttons">
          <button 
            className="primary-button"
            onClick={handleGetStarted}
          >
            Get Started with Sportagram
          </button>
          <button 
            className="secondary-button"
            onClick={handleExploreFeatures}
          >
            Explore Features
          </button>
        </div>
        
        <div className="welcome-message">
          <p>
            <strong>Welcome to Sportagram!</strong> We're excited to have you join our community of sports enthusiasts. 
            Let's make your sports journey amazing! 🚀
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccountVerificationSuccess;